import { createResourceKeys } from "@/lib/resource-context";

export const apiKeysKeys = createResourceKeys("api_keys");
